import React from "react";
import "@/App.css";
import GridBackground from "@/components/site/GridBackground";
import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import Experience from "@/components/site/Experience";
import Projects from "@/components/site/Projects";
import Skills from "@/components/site/Skills";
import Contact from "@/components/site/Contact";

function App() {
  return (
    <div className="App relative min-h-screen bg-bg-base text-ink-primary">
      <GridBackground />
      <NavBar />
      <main data-testid="main-content">
        <Hero />
        <Experience />
        <Projects />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
